<section class="about-page">
  <img
    class="about-page__bg"
    src="https://images.sitco.ru/about/about-bg.png"
    alt="">

  <div class="about-page__bar">
    <app-toolbar />
  </div>

  <div class="about-card">
    <button class="about-card__close" type="button">
      Close
    </button>

    <div class="about-card__label">
      About
    </div>

    <div class="about-card__content">
      <div class="about-card__text">
        <p>
          Lorem ipsum (/ˌlɔː.rəm ˈɪp.səm/ LOR-əm IP-səm) is a dummy or
          placeholder text commonly used in graphic design, publishing, and web
          development. It is typically a corrupted version of De finibus bonorum
          et malorum, a 1st-century BC text by the Roman statesman and
          philosopher Cicero, with words altered, added, and removed to make it
          nonsensical and improper Latin.
        </p>

        <p>
          The first two words are the truncation of dolorem ipsum ("pain itself").
          Lorem ipsum's purpose is to permit a page layout to be designed,
          independently of the copy that will subsequently populate it.
        </p>
      </div>

      <div class="about-card__meta">
        <div class="about-meta-row about-meta-row--top">
          <div>
            <span>Client:</span>
            <p>First Class Solutions Ltd</p>
          </div>

          <div>
            <span>Site</span>
            <p>ilovefirstclass.com</p>
          </div>

          <div>
            <span>Year</span>
            <p>2026</p>
          </div>
        </div>

        <div class="about-meta-row about-meta-row--bottom">
          <div>
            <span>Role:</span>
            <p>
              Web Development<br>
              Web Development<br>
              Web Development<br>
              Web Development
            </p>
          </div>

          <div>
            <span>Credits:</span>
            <p>
              Art Direction<br>
              Web Development<br>
              Brand Design<br>
              Photography
            </p>
          </div>

          <div>
            <span>&nbsp;</span>
            <p>
              Name Surname<br>
              Name Surname<br>
              Name Surname<br>
              Name Surname
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
